import { hydrateRenderedComponents } from "@streeteasy/render-service/client";

import HomePageRedesign from "../src/features/home-page-redesign/components/HomePageRedesign";

hydrateRenderedComponents("homePageRedesign", {
  HomePageRedesign
});
